export default __webpack_public_path__ + "static/media/uploader-medtronic6xG-2-1.58dd6b08.png";